import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { ClientCommunicationHistoryListComponent } from './client-communication-history-list.component';
import { TapRetryComponentModule } from '../tap-retry/tap-retry.module';
import { SalonMonsterLoadMaskModule } from '../smr-load-mask/smr-load-mask.module';
import { CommunicationItemComponentModule } from '../communication-item/communication-item.module';
import { ClientCommunicationHistoryComponentModule } from './client-communication-history/client-commnunication-hisotry.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CommunicationItemComponentModule,
    TapRetryComponentModule,
    SalonMonsterLoadMaskModule,
    ClientCommunicationHistoryComponentModule
  ],
  declarations: [
    ClientCommunicationHistoryListComponent,
  ],
  exports: [ClientCommunicationHistoryListComponent]
})
export class ClientCommunicationHistoryListComponentModule {}
